module.exports = __webpack_public_path__ + "static/img/5.c8b444b2.png";